export const BUTTON_VARIANTS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SECONDARY_DARK: "secondaryDark",
  SIMPLE: "simple",
  CIRCLE: "circle",
};
